import React, { Component } from "react";

import "./styles.css";

class TextEditorFunctionsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bold: false,
      italic: false,
      underline: false,

      componentStyle: {
        container: "text-editor-functions-menu",
        formattingMenu: "text-editor-formatting-menu",
        formattingButton: "text-editor-formatting-button",
        srcMenu: "text-editor-src-menu",
        srcButton: "text-editor-src-button",

        iconSize: " fa-md"
      }
    };
  }

  toggleBoldButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "bold");

    this.setState(prevState => ({ bold: !prevState.bold }));
  }

  toggleItalicButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "italic");

    this.setState(prevState => ({ italic: !prevState.italic }));
  }

  toggleUnderlineButton(e) {
    this.props.toggleMark(e, this.props.editorAcces, "underline");

    this.setState(prevState => ({ underline: !prevState.underline }));
  }

  render() {
    return (
      <div className={this.state.componentStyle.container}>
        <div className={this.state.componentStyle.formattingMenu}>
          <button
            id={
              this.state.bold
                ? "formatting-button-active"
                : "formatting-button-inactive"
            }
            className={this.state.componentStyle.formattingButton}
            onClick={e => this.toggleBoldButton(e)}
            onKeyPress={e => this.toggleBoldButton(e)}
          >
            <i
              className={`fa fa-bold${this.state.componentStyle.iconSize}`}
            ></i>
          </button>

          <button
            id={
              this.state.italic
                ? "formatting-button-active"
                : "formatting-button-inactive"
            }
            className={this.state.componentStyle.formattingButton}
            onClick={e => this.toggleItalicButton(e)}
            onKeyPress={e => this.toggleItalicButton(e)}
          >
            <i
              className={`fa fa-italic${this.state.componentStyle.iconSize}`}
            ></i>
          </button>
          <button
            id={
              this.state.underline
                ? "formatting-button-active"
                : "formatting-button-inactive"
            }
            className={this.state.componentStyle.formattingButton}
            onClick={e => this.toggleUnderlineButton(e)}
            onKeyPress={e => this.toggleUnderlineButton(e)}
          >
            <i
              className={`fa fa-underline${this.state.componentStyle.iconSize}`}
            ></i>
          </button>
        </div>
        <div className={this.state.componentStyle.srcMenu}>
          <button
            className={this.state.componentStyle.srcButton}
            onClick={() => this.props.showImageImporter()}
            onKeyPress={() => this.props.showImageImporter()}
          >
            <i
              className={`fa fa-image${this.state.componentStyle.iconSize}`}
            ></i>
          </button>
        </div>
      </div>
    );
  }
}

export default TextEditorFunctionsMenu;
